import { render, staticRenderFns } from "./header.component.vue?vue&type=template&id=4ca4ef80&scoped=true"
import script from "./header.component.vue?vue&type=script&lang=ts"
export * from "./header.component.vue?vue&type=script&lang=ts"
import style0 from "./header.component.vue?vue&type=style&index=0&id=4ca4ef80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca4ef80",
  null
  
)

export default component.exports